module.exports = __webpack_public_path__ + "img/login_modal_cover_image.3eb62f1b.png";